export enum CreatedByEnum {
    me = "me",
    others = "others",
}

export interface IListResult<T> {
    items: T[];
}
